import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

/**
 * TODO:
 */
// TODO: there has to be a better way to organize this stuff
export type Marker<TType> = Record<typeof Marker.SYMBOL, TType>
export namespace Marker {
  export const SYMBOL = Symbol.for(
    '@attain-apps/store.storage.config.Marker.SYMBOL',
  )

  /**
   * Applies a {@link Marker} to a config object
   */
  export function mark<TConfig extends Object.Constraint, TType extends Type>(
    config: TConfig,
    type: TType,
  ): TConfig & Marker<TType> {
    return Object.assign(config, { [SYMBOL]: type })
  }

  /**
   * TODO: explain what this enum is, when it is used and why, as well as any examples
   *
   * TODO: add JSDoc comments to each enum value to explain it
   */
  export enum Type {
    Property = 'property',
    Lookup = 'lookup',
  }
  // Needs to be before namespace is defined
  const TYPES: ReadonlySet<Type> = new Set(Object.values(Type) as Type[])
  export namespace Type {
    export const ALL: readonly Type[] = Array.from(TYPES)
    export const isType = TypeChecker.Factory.oneOf(TYPES)
    export const assertIsType: TypeAsserter<Type> =
      TypeAsserter.Factory.from(isType)
  }
}

// TODO: we should have three types of properties/entries:
// 1. store.storage.property | myStorage.selectors.myProperty, myStorage.actions.setMyProperty(val)
// 2. store.storage.object | myStorage.selectors.myObject.myObjectProperty1, myStorage.actions.updateMyObject(obj => obj.prop = 1) // Could use similar approach as electrodb with `obj` being tracker object to track updates
// 3. store.storage.lookup | myStorage.selectors.getFromMyLookup('key'), myStorage.actions.putInMyLookup(key, val)
